<div class="row justify-content-center">
  <div class="col-md-5">
    <h2 class="mb-3 text-center" *ngIf="applicationsService.application.fundingBucket ==='BURSARY'">NSFAS BURSARY</h2>
    <h2 class="mb-3 text-center" *ngIf="applicationsService.application.fundingBucket ==='LOAN'">NSFAS LOAN</h2>
    <br>

    <form (ngSubmit)="onSubmit()" #documentForm="ngForm" class="px-5 needs-validation" [ngClass]="validated===true?'was-validated':''">

      <h4 style="text-align: center;">Kindly upload following documents</h4>
      <br/>
      <p class="text-danger"><small>If you are prompted to upload the NSFAS Consent Form more than once, please upload the SAME form.
        The NSFAS Consent Form must be completed and signed  by all relevant parties.</small></p>

      <br/>

      <h4 style="text-align: center;" *ngIf="applicationsService.application.spouse && applicationsService.application.spouse.requiredDocuments && applicationsService.application.spouse.requiredDocuments.length > 0">Spouse's documents</h4>
      <div *ngIf="applicationsService.application.spouse && applicationsService.application.spouse.requiredDocuments">
        <div class="row justify-content-center" *ngFor="let requiredDocument of applicationsService.application.spouse.requiredDocuments; let i = index">
          <div class="col-md-12 text-start">
            <div class="mb-5 mt-2">
              <div class="mb-3">
                <label for="formFileSm" class="form-label">{{requiredDocument.caption}}</label>
                <input required [(ngModel)]="applicationsService.application.spouse.requiredDocuments[i]" (change)="onFileSelected($event)" appFileUpload [file]="applicationsService.application.spouse.requiredDocuments[i]" name="spouseRequiredDocument{{i}}" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" type="file">
                <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
                <div class="invalid-feedback">
                  {{applicationsService.application.spouse.requiredDocuments[i].name}} is required
                </div>
              </div>
              <div class="alert alert-light text-start text-dark" *ngIf="requiredDocument.documentType ==='SARS_CONSENT_FORM'">
                <small>Please complete the spouse section of the form. The form requires your signature and your spouse's signature. Thereafter, upload.
                </small>
                <a href="/assets/NSFAS-Applications-Consent-Form.pdf" target="_blank">{{requiredDocument.caption}}</a>
              </div>
              <small class="ps-3" *ngIf="applicationsService.application.spouse.requiredDocuments[i]">{{applicationsService.application.spouse.requiredDocuments[i].name}}</small>
            </div>
          </div>
        </div>
      </div>

      <h4 style="text-align: center;" *ngIf="applicationsService.application.father && applicationsService.application.father.requiredDocuments && applicationsService.application.father.requiredDocuments.length > 0">Father's documents</h4>

      <div *ngIf="applicationsService.application.father && applicationsService.application.father.requiredDocuments">
        <div class="row justify-content-center" *ngFor="let requiredDocument of applicationsService.application.father.requiredDocuments; let i = index">
          <div class="col-md-12 text-start">
            <div class="mb-5 mt-2">
              <div class="mb-3">
                <label for="formFileSm" class="form-label">{{requiredDocument.caption}}</label>
                <input required [(ngModel)]="applicationsService.application.father.requiredDocuments[i]" (change)="onFileSelected($event)" appFileUpload [file]="applicationsService.application.father.requiredDocuments[i]" name="fatherRequiredDocument{{i}}" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" type="file">
                 <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
                <div class="invalid-feedback">
                  {{applicationsService.application.father.requiredDocuments[i].name}} is required
                </div>
              </div>
              <div class="alert alert-light text-start text-dark" *ngIf="requiredDocument.documentType ==='SARS_CONSENT_FORM'">
                <small>Please complete the father section of the form. The form requires your signature and your father's signature. Thereafter, upload.
                </small>
                <a href="/assets/NSFAS-Applications-Consent-Form.pdf" target="_blank">{{requiredDocument.caption}}</a>
              </div>
              <small class="ps-3" *ngIf="applicationsService.application.father.requiredDocuments[i]">{{applicationsService.application.father.requiredDocuments[i].name}}</small>
            </div>
          </div>
        </div>
      </div>

      <h4 style="text-align: center;" *ngIf="applicationsService.application.mother && applicationsService.application.mother.requiredDocuments && applicationsService.application.mother.requiredDocuments.length> 0">Mother's documents</h4>

      <div *ngIf="applicationsService.application.mother && applicationsService.application.mother.requiredDocuments">
        <div class="row justify-content-center" *ngFor="let requiredDocument of applicationsService.application.mother.requiredDocuments; let i = index">
          <div class="col-md-12 text-start">
            <div class="mb-5 mt-2">
              <div class="mb-3">
                <label for="formFileSm" class="form-label">{{requiredDocument.caption}}</label>
                <input required [(ngModel)]="applicationsService.application.mother.requiredDocuments[i]" (change)="onFileSelected($event)" appFileUpload [file]="applicationsService.application.mother.requiredDocuments[i]" name="motherRequiredDocument{{i}}" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" type="file">
                <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
                <div class="invalid-feedback">
                  {{applicationsService.application.mother.requiredDocuments[i].name}} is required
                </div>
              </div>
              <div class="alert alert-light text-start text-dark" *ngIf="requiredDocument.documentType ==='SARS_CONSENT_FORM'">
                <small>Please complete the mother section of the form. The form requires your signature and your mother's signature. Thereafter, upload.
                </small>
                <a href="/assets/NSFAS-Applications-Consent-Form.pdf" target="_blank">{{requiredDocument.caption}}</a>
              </div>
              <small class="ps-3" *ngIf="applicationsService.application.mother.requiredDocuments[i]">{{applicationsService.application.mother.requiredDocuments[i].name}}</small>
            </div>
          </div>
        </div>
      </div>

      <h4 style="text-align: center;" *ngIf="applicationsService.application.guardian && applicationsService.application.guardian.requiredDocuments && applicationsService.application.guardian.requiredDocuments.length > 0">Guardian's documents</h4>

      <div *ngIf="applicationsService.application.guardian && applicationsService.application.guardian.requiredDocuments">
        <div class="row justify-content-center" *ngFor="let requiredDocument of applicationsService.application.guardian.requiredDocuments; let i = index">
          <div class="col-md-12 text-start">
            <div class="mb-5 mt-2">
              <div class="mb-3">
                <label for="formFileSm" class="form-label">{{requiredDocument.caption}}</label>
                <input required [(ngModel)]="applicationsService.application.guardian.requiredDocuments[i]" (change)="onFileSelected($event)" appFileUpload name="guardianRequiredDocument{{i}}" [file]="applicationsService.application.guardian.requiredDocuments[i]" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" type="file">
                <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
                <div class="invalid-feedback">
                  {{applicationsService.application.guardian.requiredDocuments[i].name}} is required
                </div>
              </div>
              <div class="alert alert-light text-start text-dark" *ngIf="requiredDocument.documentType ==='SARS_CONSENT_FORM'">
                <small>Please complete the guardian section of the form. The form requires your signature and your guardian's signature. Thereafter, upload.
                </small>
                <a href="/assets/NSFAS-Applications-Consent-Form.pdf" target="_blank">{{requiredDocument.caption}}</a>
              </div>
              <small class="ps-3" *ngIf="applicationsService.application.guardian.requiredDocuments[i]">{{applicationsService.application.guardian.requiredDocuments[i].name}}</small>
            </div>
          </div>
        </div>
      </div>


      <h4 style="text-align: center;" *ngIf="applicationsService.application.disabilityAnnexure || applicationsService.application.provisionalOfferLetter || applicationsService.application.vulnerableChildOrNonSassDeclaration || applicationsService.application.consentForm">Applicant's documents</h4>
      <div class="row justify-content-center" *ngIf="applicationsService.application.disabilityAnnexure">
        <div class="col-md-12 text-start">
          <div class="mb-5 mt-2">
            <div class="mb-3">
              <label for="formFileSm" class="form-label">{{applicationsService.application.disabilityAnnexure.caption}}</label>
              <input required [(ngModel)]="applicationsService.application.disabilityAnnexure" (change)="onFileSelected($event)" appFileUpload   name="disabilityAnnexure" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" id="formFileSm" type="file">
              <a href="/assets/NSFASDisabilityAnnexure.pdf" target="_blank">Download Disability Annexure</a>
              <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
              <div class="invalid-feedback">
                {{applicationsService.application.disabilityAnnexure.caption}} is required
              </div>
            </div>
            <small class="ps-3" *ngIf="applicationsService.application.disabilityAnnexure">{{applicationsService.application.disabilityAnnexure.name}}</small>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center" *ngFor="let docs in applicationsService.application?.requiredDocuments">
        <div class="col-md-12 text-start" *ngIf="docs.documentType =='SARS_CONSENT_FORM' && !applicationsService.application.sassaFunded">
          <div class="mb-5 mt-2">
            <div class="mb-3">
              <label for="formFileSm" class="form-label">{{applicationsService.application.consentForm?.caption}}</label>
              <input required [(ngModel)]="applicationsService.application.consentForm" appFileUpload   name="sarsConsent" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" id="formFileSm" type="file">
              <div class="invalid-feedback">
                {{applicationsService.application.consentForm?.caption}} is required Correct
              </div>
            </div>
            <small class="ps-3" *ngIf="!applicationsService.application.consentForm">[PDF,DOC,DOCX,JPG,JPEG,PNG], max 20mb</small>
            <small class="ps-3" *ngIf="applicationsService.application.consentForm">{{applicationsService.application.consentForm?.name}}</small>
          </div>
        </div>
      </div> -->
      <div class="row justify-content-center" *ngIf="!applicationsService.application.sassaFunded && applicationsService.application?.consentForm">
        <div class="col-md-12 text-start">
          <div class="mb-5 mt-2">
            <div class="mb-3">
              <label for="formFileSm" class="form-label">{{applicationsService.application.consentForm?.caption}}</label>
              <input required [(ngModel)]="applicationsService.application.consentForm" (change)="onFileSelected($event)" appFileUpload   name="sarsConsent" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" id="formFileSm" type="file">
              <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
              <div class="alert alert-light text-start text-dark">
                <small>Please complete the applicant section of the form. The form requires your signature. Thereafter, upload.
                </small>
                <a href="/assets/NSFAS-Applications-Consent-Form.pdf" target="_blank">Download NSFAS Consent Form</a>
              </div>
              <div class="invalid-feedback">
                {{applicationsService.application.consentForm?.caption}} is required Incorrect
              </div>
            </div>
            <small class="ps-3" *ngIf="applicationsService.application.consentForm">{{applicationsService.application.consentForm?.name}}</small>
          </div>
        </div>
      </div>

      <div class="row justify-content-center" *ngIf="applicationsService.application.vulnerableChildOrNonSassDeclaration">
        <div class="col-md-12 text-start">
          <div class="mb-5 mt-2">
            <div class="mb-3">
              <label for="formFileSm" class="form-label">{{applicationsService.application.vulnerableChildOrNonSassDeclaration.caption}}</label>
              <input required [(ngModel)]="applicationsService.application.vulnerableChildOrNonSassDeclaration" (change)="onFileSelected($event)" appFileUpload   name="vulnerableChildOrNonSassDeclaration" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" id="vulnerableChildOrNonSassDeclaration" type="file">
              <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
              <div *ngIf="applicationsService.application.age<18">
                <a href="/assets/NSFASOrphanorVulnerableChildDeclaration.pdf" target="_blank">Download Orphan or Vulnerable Child Form</a>
              </div>

              <div *ngIf="applicationsService.application.age>=18">
                <a href="/assets/NSFASDeclarationForm.pdf" target="_blank">Download NSFAS Declaration Form</a>
              </div>
              <div class="invalid-feedback">
                {{applicationsService.application.vulnerableChildOrNonSassDeclaration.caption}} is required
              </div>
            </div>
            <small class="ps-3" *ngIf="applicationsService.application.vulnerableChildOrNonSassDeclaration">{{applicationsService.application.vulnerableChildOrNonSassDeclaration.name}}</small>
          </div>
        </div>
      </div>

      <div class="row justify-content-center" *ngIf="applicationsService.application.provisionalOfferLetter">
        <div class="col-md-12 text-start">
          <div class="mb-5 mt-2">
            <div class="mb-3">
              <label for="formFileSm" class="form-label">{{applicationsService.application.provisionalOfferLetter.caption}}</label>
              <input required [(ngModel)]="applicationsService.application.provisionalOfferLetter" (change)="onFileSelected($event)" appFileUpload   name="provisionalOfferLetter" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="form-control form-control-sm" id="provisionalOfferLetter" type="file">
              <small class="ps-3">[PDF,DOC,DOCX,JPG,JPEG,PNG], MAX 20MB</small>
              <div class="invalid-feedback">
                {{applicationsService.application.provisionalOfferLetter.caption}} is required
              </div>
            </div>
            <small class="ps-3" *ngIf="applicationsService.application.provisionalOfferLetter">{{applicationsService.application.provisionalOfferLetter.name}}</small>
          </div>
        </div>
      </div>
  <div class="row">
    <div class="col-md-6">
      <div class="d-grid gap-2">

        <button class="btn btn-outline-dark btn-lg mb-3" type="button" (click)="previous()">Previous</button>
      </div>

    </div>
    <div class="col-md-6">
      <div class="d-grid gap-2">

        <button class="btn btn-primary btn-lg mb-3" type="submit" >Next</button>
      </div>

    </div>
  </div>
  </form>

</div>

</div>

